export default "__VITE_ASSET__Csss$gnd__"